import { hits } from "instantsearch.js/es/widgets";

const articles = hits({
  container: "#hits",
  templates: {
    item: `<div class="hit mt-4">
                <div class="hit-content">
                <div class="d-flex flex-row">
                    <h2 class="hit-name h4"><a href="/elearning/{{chapter_slug}}/{{article_slug}}#paragraph-{{position}}">{{{_highlightResult.title.value}}}</a></h2>
                    <p class="ml-2 searchLink" style="font-size: 18px; cursor: copy;" linkUrl="https://dinkemi.se/elearning/{{chapter_slug}}/{{article_slug}}#paragraph-{{position}}"><i class="fas fa-link" id="search-result-{{chapter_slug}}-{{article_slug}}-{{position}}"></i></p>
                </div>
                    <p class="hit-category">Chapter: {{{chapter_title}}} / Article: {{{_highlightResult.article_title.value}}}</p>
                    <p class="hit-description">{{#helpers.snippet}}{ "attribute": "body" }{{/helpers.snippet}}</p>
                </div>
            </div>
            `,
    empty: `<div>
                <p>${noResultsText} "{{ query }}"</p>
              </div>`
  }
});

export default articles;
